import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireTwoFactorSetup = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user.two_factor_enabled) {
    return <Navigate to="/setup-2fa" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireTwoFactorSetup;
